export const SeedTime = 400;
